export default __webpack_public_path__ + "static/media/twi.ac0e1ee5.svg";